import axios from 'axios';
import { loadStatechart } from '../state';
import { processAppSwitcherHeaders } from './process-app-switcher-headers';
import { reconcileApiUrl } from './reconcile-api-url';
export const requestFromApi = async (options, config = {}) => {
    const { headers = {}, method = 'GET', url: urlSubPath = '' } = config;
    const statechart = loadStatechart();
    const url = reconcileApiUrl(options, urlSubPath);
    try {
        // @ts-expect-error
        const response = await axios.request({
            ...config,
            // @ts-expect-error
            ...processAppSwitcherHeaders(options, headers),
            method,
            url
        });
        const { status } = response;
        if (status === 401) {
            // tell app switcher we are logged out if we get a 401 unauthorized
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            statechart.sendEvent('logout');
        }
        return response;
    }
    catch (err) {
        return {
            error: {
                message: err?.message
            }
        };
    }
};
